import React from 'react';

type VisibilityIconProps = {
  width?: string;
  height?: string;
  color?: string;
  style?: React.CSSProperties;
};

function VisibilityIcon({
  width = '14',
  height = '14',
  color = '#6267AC',
}: VisibilityIconProps) {
  return (
    <svg
      width={width}
      height={height}
      color={color}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.41174 7.41537C1.3323 7.28958 1.29257 7.22668 1.27034 7.12967C1.25364 7.05681 1.25364 6.94189 1.27034 6.86902C1.29257 6.77201 1.3323 6.70912 1.41174 6.58333C2.06823 5.54384 4.02232 2.91602 7.00024 2.91602C9.97815 2.91602 11.9322 5.54384 12.5887 6.58333C12.6682 6.70912 12.7079 6.77201 12.7301 6.86902C12.7468 6.94189 12.7468 7.05681 12.7301 7.12967C12.7079 7.22668 12.6682 7.28958 12.5887 7.41537C11.9322 8.45486 9.97815 11.0827 7.00024 11.0827C4.02232 11.0827 2.06823 8.45486 1.41174 7.41537Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.00024 8.74935C7.96673 8.74935 8.75024 7.96585 8.75024 6.99935C8.75024 6.03285 7.96673 5.24935 7.00024 5.24935C6.03374 5.24935 5.25024 6.03285 5.25024 6.99935C5.25024 7.96585 6.03374 8.74935 7.00024 8.74935Z'
        stroke={color}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default VisibilityIcon;
